export enum CalendarViewType {
  day = 'day',
  week = 'week',
  month = 'month',
}
